import { Modal } from "react-bootstrap";

import classes from "./PasswordModal.module.scss";

import { Collapse, InputAdornment, TextField } from "@mui/material";
import { push } from "connected-react-router";
import { useEffect, useState } from "react";
import { FaCheck, FaEye, FaEyeSlash, FaTimesCircle } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { IPasswordModalProps } from "./module/constants";
import messages from "./module/messages";

import {
  changeFirstPasswordAction,
  getPasswordPolicyAction,
  postPasswordAction,
  resetModalOtpStateAction,
  setFirstAccessAction,
  setOldPasswordAction,
} from "../../../../pages/Login/module/actions";
import {
  passwordPolicySelector,
  selectOldPwdSelector,
  selectPasswordResponse,
  tokenSelector,
  tokenTypeSelector,
  userLoginSelector,
} from "../../../../pages/Login/module/selectors";
import CustomModal from "../../CustomModal/CustomModal";
import { IResponseState } from "../../ResponseModal/module/constants";
import ResponseModal from "../../ResponseModal/ResponseModal";
import {
  checkPwdContainsOnlyAllowedSpecialChars,
  checkPwdNotContainsSpecialChars,
  generateEscapedRegexPattern,
} from "../../../../utils/utils";

const PasswordModal = (props: IPasswordModalProps) => {
  const {
    changeLocation,
    token,
    tokenType,
    policy,
    getPolicy,
    user,
    sendPassword,
    statusPassword,
    isFirstAccess = false,
    oldPassword,
    resetResponseModal,
    setFirstAccess,
    setOldPassword,
    changeFirstPwd,
  } = props;

  const [showError, setShowError] = useState<boolean>(false);
  const [showResponseModal, setShowResponseModal] = useState<boolean>(false);
  const [newPwd, setNewPwd] = useState<string>("");
  const [newPwdConfirm, setNewPwdConfirm] = useState<string>("");
  const [isPossibleToConfirm, setIsPossibleToConfirm] = useState<boolean>(true);

  const [checkMinLength, setCheckMinLength] = useState<boolean>(false);
  const [checkMaxLength, setCheckMaxLength] = useState<boolean>(false);
  const [checkLowerCase, setCheckLowerCase] = useState<boolean>(false);
  const [checkUpperCase, setCheckUpperCase] = useState<boolean>(false);
  const [checkNumber, setCheckNumber] = useState<boolean>(false);
  const [checkSpecialChar, setCheckSpecialChar] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(true);
  const [showConfPassword, setShowConfPassword] = useState<boolean>(true);

  useEffect(() => {
    if (token) {
      getPolicy(/* user */);
    }
  }, [token]);

  const handleChangeNewPwd = (event: React.ChangeEvent<HTMLInputElement>) =>
    setNewPwd(event.target.value);

  const handleChangeNewPwdConfirm = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => setNewPwdConfirm(event.target.value);

  const handleSendPassword = () => {
    let data = `password=${newPwd}`;

    let fullToken = token;

    if (data.length > 9) {
      isFirstAccess
        ? changeFirstPwd({ token: token, newPwd: newPwd, oldPwd: oldPassword! })
        : sendPassword(fullToken, data);
      setShowResponseModal(true);
    }
  };

  useEffect(() => {
    if (statusPassword === IResponseState.ERROR) setShowError(true);
    else setShowError(false);
  }, [statusPassword]);

  useEffect(() => {
    //check min length
    if (newPwd.length >= policy.minLength) {
      setCheckMinLength(true);
    } else {
      setCheckMinLength(false);
    }

    //check max length
    if (newPwd.length <= policy.maxLength) {
      setCheckMaxLength(true);
    } else {
      setCheckMaxLength(false);
    }

    //check lower case
    const regexLowerCase = /[a-z]/g;
    if (policy.lowerCase && policy.lowerCase.allowed) {
      const arrayLowerCase = Array.from(newPwd.matchAll(regexLowerCase));
      if (arrayLowerCase.length >= policy.lowerCase.min) {
        setCheckLowerCase(true);
      } else {
        setCheckLowerCase(false);
      }
    } else {
      setCheckLowerCase(() => {
        return regexLowerCase.test(newPwd) ? false : true;
      });
    }

    //check upper case
    const regexUpperCase = /[A-Z]/g;
    if (policy.upperCase && policy.upperCase.allowed) {
      const arrayUpperCase = Array.from(newPwd.matchAll(regexUpperCase));
      if (arrayUpperCase.length >= policy.upperCase.min) {
        setCheckUpperCase(true);
      } else {
        setCheckUpperCase(false);
      }
    } else {
      setCheckUpperCase(() => {
        return regexUpperCase.test(newPwd) ? false : true;
      });
    }

    //check number
    const regexNumber = /[0-9]/g;
    if (policy.numberCase && policy.numberCase.allowed) {
      const arrayNumber = Array.from(newPwd.matchAll(regexNumber));
      if (arrayNumber.length >= policy.numberCase.min) {
        setCheckNumber(true);
      } else {
        setCheckNumber(false);
      }
    } else {
      setCheckNumber(() => {
        return regexUpperCase.test(newPwd) ? false : true;
      });
    }

    //check special/invalid char
    const regexCondition =
      policy &&
      policy.specialChar &&
      policy.specialChar.allowed &&
      policy.specialChar.allowedCharacters
        ? generateEscapedRegexPattern(policy.specialChar.allowedCharacters)
        : "";

    if (policy.specialChar && policy.specialChar.allowed) {
      if (
        checkPwdContainsOnlyAllowedSpecialChars(
          newPwd,
          regexCondition,
          policy.specialChar.min
        )
      ) {
        setCheckSpecialChar(true);
      } else {
        setCheckSpecialChar(false);
      }
    } else {
      setCheckSpecialChar(() => {
        return checkPwdNotContainsSpecialChars(newPwd);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPwd, newPwdConfirm]);

  useEffect(() => {
    setIsPossibleToConfirm(
      newPwd !== "" &&
        newPwd === newPwdConfirm &&
        checkMinLength &&
        checkMaxLength &&
        checkLowerCase &&
        checkUpperCase &&
        checkNumber &&
        checkSpecialChar
    );
  }, [
    newPwd,
    newPwdConfirm,
    checkMinLength,
    checkMaxLength,
    checkLowerCase,
    checkUpperCase,
    checkNumber,
    checkSpecialChar,
  ]);

  const handleClose = () => {
    setFirstAccess(false);
    setOldPassword(null);
    setShowResponseModal(false);
    resetResponseModal();
    props.onConfirm();
  };

  const cancelHandler = () => {
    setFirstAccess(false);
    setOldPassword(null);
    resetResponseModal();
    props.onClose();
  };

  return (
    <>
      <ResponseModal
        show={showResponseModal}
        state={statusPassword}
        onClose={handleClose}
      />

      <CustomModal
        size="sm"
        title={<FormattedMessage {...messages.errorPassword} />}
        show={showError}
        onClose={() => setShowError(false)}
        message={<FormattedMessage {...messages.errorPasswordContent} />}
      />

      <Modal
        show={props.show}
        size={"xl"}
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            {isFirstAccess ? (
              <FormattedMessage {...messages.firstAccessTitle} />
            ) : (
              <FormattedMessage {...messages.PasswordModalTitle} />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <div className={classes["change-password-wrapper"]}>
            <div className={classes["change-password-form"]}>
              <div className={classes["input-field-change-password"]}>
                <TextField
                  onChange={handleChangeNewPwd}
                  label={
                    <FormattedMessage {...messages.labelChangePasswordField} />
                  }
                  type={showPassword ? "password" : "text"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div onClick={() => setShowPassword((prev) => !prev)}>
                          {showPassword ? (
                            <FaEye style={{ cursor: "pointer" }} />
                          ) : (
                            <FaEyeSlash style={{ cursor: "pointer" }} />
                          )}
                        </div>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className={classes["input-field-change-password"]}>
                <TextField
                  onChange={handleChangeNewPwdConfirm}
                  label={
                    <FormattedMessage
                      {...messages.labelChangePasswordConfirmField}
                    />
                  }
                  type={showConfPassword ? "password" : "text"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div
                          onClick={() => setShowConfPassword((prev) => !prev)}
                        >
                          {showConfPassword ? (
                            <FaEye style={{ cursor: "pointer" }} />
                          ) : (
                            <FaEyeSlash style={{ cursor: "pointer" }} />
                          )}
                        </div>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className={classes["divider-vertical"]} />
            <div>
              <Collapse in={!!policy}>
                <div className={classes["password-policy-header"]}>
                  <FormattedMessage {...messages.passwordPolicy} />
                </div>
                <ul className={classes["password-policy-list"]}>
                  {policy.minLength && (
                    <li
                      className={
                        classes[
                          `password-policy${checkMinLength ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkMinLength ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val: policy.minLength,
                        }}
                        {...messages.checkMinLength}
                      />
                    </li>
                  )}
                  {policy.maxLength && (
                    <li
                      className={
                        classes[
                          `password-policy${checkMaxLength ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkMaxLength ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val: policy.maxLength,
                        }}
                        {...messages.checkMaxLength}
                      />
                    </li>
                  )}
                  {policy.lowerCase && policy.lowerCase.allowed && (
                    <li
                      className={
                        classes[
                          `password-policy${checkLowerCase ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkLowerCase ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val: policy.lowerCase.min,
                        }}
                        {...messages.checkLowerCase}
                      />
                    </li>
                  )}
                  {policy.upperCase && policy.upperCase.allowed && (
                    <li
                      className={
                        classes[
                          `password-policy${checkUpperCase ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkUpperCase ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val: policy.upperCase.min,
                        }}
                        {...messages.checkUpperCase}
                      />
                    </li>
                  )}
                  {policy.numberCase && policy.numberCase.allowed && (
                    <li
                      className={
                        classes[
                          `password-policy${checkNumber ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkNumber ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val: policy.numberCase.min,
                        }}
                        {...messages.checkNumber}
                      />
                    </li>
                  )}
                  {policy.specialChar && policy.specialChar.allowed && (
                    <li
                      className={
                        classes[
                          `password-policy${checkSpecialChar ? "" : "__error"}`
                        ]
                      }
                    >
                      {checkSpecialChar ? <FaCheck /> : <FaTimesCircle />}
                      {" - "}
                      <FormattedMessage
                        values={{
                          val1: policy.specialChar.min,
                          val2: policy.specialChar.allowedCharacters?.join(" "),
                        }}
                        {...messages.checkSpecialChar}
                      />
                    </li>
                  )}
                </ul>
              </Collapse>
              <Collapse in={newPwdConfirm !== ""}>
                <ul className={classes["password-policy-list"]}>
                  <li
                    className={
                      classes[
                        `password-policy${
                          newPwd === newPwdConfirm ? "" : "__error"
                        }`
                      ]
                    }
                  >
                    {newPwd === newPwdConfirm ? <FaCheck /> : <FaTimesCircle />}
                    <FormattedMessage {...messages.checkSamePassword} />
                  </li>
                </ul>
              </Collapse>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={cancelHandler}
          >
            <FormattedMessage {...messages.PasswordModalClose} />
          </button>
          <button
            disabled={!isPossibleToConfirm}
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={handleSendPassword}
          >
            <FormattedMessage {...messages.PasswordModalConfirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    token: tokenSelector,
    policy: passwordPolicySelector,
    user: userLoginSelector,
    tokenType: tokenTypeSelector,
    statusPassword: selectPasswordResponse,
    oldPassword: selectOldPwdSelector,
  });

/* DISPATCH ACTIONS */
const mapDispatchToProps: any = {
  changeLocation: (url: string) => push(url),
  getPolicy: () => getPasswordPolicyAction(),
  sendPassword: (token: string, data: string) =>
    postPasswordAction(token, data),
  resetResponseModal: resetModalOtpStateAction,
  setFirstAccess: setFirstAccessAction,
  setOldPassword: setOldPasswordAction,
  changeFirstPwd: changeFirstPasswordAction,
};

//CONST CONNECT
const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(PasswordModal);
